module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/na-27bc2313a9535106015ccb6e98c26b29.svg";